import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { OptionsService } from '../services/options.service'

export function* setShiftOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getShiftOptions])
    const { entity } = response
    yield put(actions.setShiftOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setShiftOptions() error: ${e}`))
  }
}
export function* setShiftOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setShiftOptions)
}
